import { useSelector } from 'react-redux'
import { institutionItemSelectors } from '@ucheba/store/institutions/item'
import { useRouter } from 'next/router'
import { useMemo } from 'react'

interface IUseUzCanonical {
  (): {
    canonical: string | undefined
  }
}

export const useUzCanonical: IUseUzCanonical = () => {
  const currentInstitution = useSelector(institutionItemSelectors.currentInstitution)
  const { asPath } = useRouter()

  const canonical = useMemo(() => {
    if (currentInstitution.domain) {
      return `https://${currentInstitution?.domain?.slug}.ucheba.ru${asPath}`
    }

    return undefined
  }, [currentInstitution, asPath])

  return {
    canonical,
  }
}
